import PropTypes from 'prop-types';
import React from 'react';

// Components
import {
  FlexCol,
  FlexRow,
  H2,
  H3,
  H4,
  HR,
  P,
} from 'common/styles/oc-styled-components';
import { colors } from 'common/styles/style-constants';

import { COUNTRY } from '../../../../../common/constants';
import ShieldGeneric from '../../../../common/components/svgs/ShieldGeneric';

// Others

import {
  InsuranceCardTitle,
  MemberIdHighlight,
  SampleInsuranceCard,
} from './styled-components';

const MemberIDHelperModal = ({ insuranceProvider, patient, country }) => {
  const patientFullName =
    patient?.firstName && `${patient.firstName} ${patient?.lastName}`;
  const patientNameDisplay =
    patientFullName || (patient?.gender === 'F' ? 'Jane Doe' : 'John Doe');

  return (
    <FlexCol align="flex-start">
      <H2 fontWeight="600">What is a Member ID?</H2>
      <P margin="0 0 20px">
        Your Member ID number identifies you as a covered member of{' '}
        <span className="sensitive-data">{insuranceProvider}</span>. Your Member
        ID is what dentists use to make sure you are covered for a treatment when
        you seek care.
      </P>
      <P margin="0 0 20px">
        Other names for Member ID include: <br />
        <em>Subscriber / Enrollee / Policy / Membership / Military</em>
      </P>
      <P margin="0 0 20px">
        Note: Some providers use your{' '}
        {country === COUNTRY.unitedStates
          ? 'Social Security Number (SSN)'
          : 'Social Insurance Number (SIN)'}{' '}
        in place of a Member ID.
      </P>
      <HR border={`1px solid ${colors.nickel}`} width="100%" />
      <H2 margin="10px 0">Where do I find my Member ID?</H2>
      <P margin="0 0 15px">
        You can find your Member ID number on your Member ID card. We've
        provided a sample below.
      </P>
      <SampleInsuranceCard margin="0 0 20px">
        <FlexRow margin="0 0 15px" align="flex-start">
          <ShieldGeneric width="20px" />
          <H3 color={colors.silver} margin="0 0 0 10px" className="sensitive-data">
            {insuranceProvider}
          </H3>
        </FlexRow>
        <InsuranceCardTitle>Member Name</InsuranceCardTitle>
        <H4 className="sensitive-data">{patientNameDisplay}</H4>
        <FlexRow justify="space-between">
          <MemberIdHighlight>
            <InsuranceCardTitle>Member ID</InsuranceCardTitle>
            <P fontWeight="400">XXXXXXXXXX</P>
          </MemberIdHighlight>
          {country === COUNTRY.unitedStates
            && (
              <FlexCol padding="5px 0 0">
                <InsuranceCardTitle>Group ID</InsuranceCardTitle>
                <P fontWeight="400">XXXXXXX</P>
              </FlexCol>
            )}
        </FlexRow>
      </SampleInsuranceCard>
      <P margin="0 0 10px">Other place your Member ID may be found:</P>
      <ul>
        <li>
          <em>Online insurance portal</em>
        </li>
        <li>
          <em>Employer Human Resources</em>
        </li>
        <li>
          <em>Employee Handbook</em>
        </li>
      </ul>
    </FlexCol>
  );
};

MemberIDHelperModal.propTypes = {
  insuranceProvider: PropTypes.string,
  patient: PropTypes.object,
  country: PropTypes.string,
};

export default MemberIDHelperModal;
